import { postRunEvents } from '#shared/api/gamelab';
import { defineClientModule, type ModuleRoute } from '@/app/module';
import { api } from '@/lib/api';
import { registerOutboxStream } from '@/lib/outbox';
import { copy } from './copy';
import { initLabOffline } from './queries';

/**
 * gamelab: DSL games from the agent connector. The shelf, requests, the paste-a-draft editor, the
 * play runtime and the Admin agent page. See docs/MODULE-GUIDE-client.md. Keep this file light:
 * data and lazy imports only.
 */
const routes: ModuleRoute[] = [
  { path: '/lab', screen: () => import('./screens/Lab'), tab: 'play' },
  { path: '/lab/ask', screen: () => import('./screens/Ask'), tab: 'play' },
  { path: '/lab/requests/:id', screen: () => import('./screens/Request'), tab: 'play' },
  { path: '/lab/draft', screen: () => import('./screens/Draft'), tab: 'play' },
  { path: '/lab/draft/:id', screen: () => import('./screens/Draft'), tab: 'play' },
  { path: '/lab/g/:defId', screen: () => import('./screens/GameDetail'), tab: 'play' },
  { path: '/lab/g/:defId/dry', screen: () => import('./screens/DryRun'), tab: 'play' },
  { path: '/lab/run/new/:defId', screen: () => import('./screens/RunNew'), tab: 'play' },
  { path: '/lab/run/:runId', screen: () => import('./screens/Run'), tab: 'play', layout: 'bare' },
  { path: '/lab/run/:runId/watch', screen: () => import('./screens/Watch'), tab: 'play', layout: 'bare' },
  { path: '/lab/run/:runId/result', screen: () => import('./screens/Result'), tab: 'play' },
  { path: '/admin/agent', screen: () => import('./screens/Agent'), tab: 'me' },
];

export default defineClientModule({
  name: 'gamelab',
  routes,
  playHubTiles: [
    { id: 'lab', order: 50, title: 'Game Lab', sub: copy.tile, to: '/lab', color: 'mint', icon: 'flask', size: 'wide' },
  ],
  homeCards: [{ id: 'fresh', order: 40, component: () => import('./parts/FreshCard') }],
  meSections: [{ id: 'lab', order: 40, title: copy.labStrip.title, component: () => import('./parts/MeLab') }],
  profileSections: [{ id: 'lab', order: 50, title: copy.labStrip.title, component: () => import('./parts/LabStrip') }],
  slots: {
    'admin.section': { order: 20, component: () => import('./parts/LabAdmin') },
    'h2h.extra': { order: 10, component: () => import('./parts/LabH2HLine') },
    'session.recap': { order: 20, component: () => import('./parts/LabRecap') },
  },
  init() {
    registerOutboxStream('lab', { url: (id) => api.url(postRunEvents, { params: { id } }) });
    initLabOffline();
  },
});
